import React, { Component } from "react";
import { debounce } from "util";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import { Page, Fab } from "components/support";

import { colors } from "assets";

import Filter from "./filter";
import DataTable from "./data-table";

export default class ProductView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { filter, loading } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Opcionais
            </Typography>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Filter
              onFilter={debounce(
                filter => presenter.handleFilterChange(filter),
                500
              )}
              loading={loading}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={12} xs={12}>
            <DataTable
              filter={filter}
              loading={loading}
              setLoading={presenter.setLoading}
            />
          </Col>
        </Row>

        <Fab
          backgroundColor={colors.button.secondary}
          onClick={() => presenter.onCreate()}
          icon="add"
        />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/view.jsx